(function () {
  'use strict';

  function debounce(fn, delay) {
    var timer;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  }

  function init() {
    var section = document.querySelector('[data-faq-section]');
    if (!section) return;

    var pills = section.querySelectorAll('[data-faq-filter]');
    var items = section.querySelectorAll('[data-faq-category]');
    var searchInput = section.querySelector('[data-faq-search]');
    var activeCategoryId = 'all';

    function setActivePill(categoryId) {
      pills.forEach(function (pill) {
        var li = pill.closest('.faq__categories-list-item');
        if (!li) return;
        if (pill.getAttribute('data-faq-filter') === categoryId) {
          li.classList.add('faq__categories-list-item--active');
        } else {
          li.classList.remove('faq__categories-list-item--active');
        }
      });
    }

    function filterByCategory(categoryId) {
      activeCategoryId = categoryId;

      // Clear search input when switching categories
      if (searchInput) {
        searchInput.value = '';
      }

      setActivePill(categoryId);

      items.forEach(function (item) {
        if (categoryId === 'all' || item.getAttribute('data-faq-category') === categoryId) {
          item.classList.remove('faq-hidden');
        } else {
          item.classList.add('faq-hidden');
          if (item.tagName === 'DETAILS') {
            item.removeAttribute('open');
          }
        }
      });

      updateCategoryHeadingVisibility();
    }

    function filterBySearch(query) {
      query = query.toLowerCase().trim();

      if (!query) {
        filterByCategory(activeCategoryId);
        return;
      }

      // Reset all pills to inactive during search
      pills.forEach(function (pill) {
        var li = pill.closest('.faq__categories-list-item');
        if (li) li.classList.remove('faq__categories-list-item--active');
      });

      var visibleCategories = {};

      items.forEach(function (item) {
        var tagName = item.tagName;

        if (tagName === 'DETAILS') {
          var questionText = '';
          var answerText = '';
          var summaryEl = item.querySelector('.faq__summary-heading');
          var answerEl = item.querySelector('.faq__answer-content');

          if (summaryEl) questionText = summaryEl.textContent.toLowerCase();
          if (answerEl) answerText = answerEl.textContent.toLowerCase();

          var matches = questionText.indexOf(query) !== -1 || answerText.indexOf(query) !== -1;

          if (matches) {
            item.classList.remove('faq-hidden');
            var catId = item.getAttribute('data-faq-category');
            if (catId) visibleCategories[catId] = true;
          } else {
            item.classList.add('faq-hidden');
            item.removeAttribute('open');
          }
        }
      });

      // Show/hide headings and subheadings based on whether their category has visible questions
      items.forEach(function (item) {
        var tagName = item.tagName;
        if (tagName === 'H3' || tagName === 'H4') {
          var catId = item.getAttribute('data-faq-category');
          if (visibleCategories[catId]) {
            item.classList.remove('faq-hidden');
          } else {
            item.classList.add('faq-hidden');
          }
        }
      });

      updateSubheadingVisibility();
    }

    function updateCategoryHeadingVisibility() {
      // After category filter, check if each subheading has visible questions after it
      updateSubheadingVisibility();
    }

    function updateSubheadingVisibility() {
      // For each subheading, check if there are any visible questions between it and the next heading/subheading
      var allItems = section.querySelectorAll('.faq__heading, .faq__subheading, .faq__details');
      var currentSubheading = null;
      var hasVisibleQuestions = false;

      for (var i = 0; i < allItems.length; i++) {
        var item = allItems[i];

        if (item.classList.contains('faq__heading') || item.classList.contains('faq__subheading')) {
          // Finalize previous subheading
          if (currentSubheading) {
            if (!hasVisibleQuestions) {
              currentSubheading.classList.add('faq-hidden');
            }
          }

          if (item.classList.contains('faq__subheading')) {
            currentSubheading = item;
            hasVisibleQuestions = false;
          } else {
            currentSubheading = null;
            hasVisibleQuestions = false;
          }
        } else if (item.classList.contains('faq__details')) {
          if (!item.classList.contains('faq-hidden')) {
            hasVisibleQuestions = true;
          }
        }
      }

      // Finalize last subheading
      if (currentSubheading && !hasVisibleQuestions) {
        currentSubheading.classList.add('faq-hidden');
      }
    }

    // Category pill click handlers
    pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        var categoryId = pill.getAttribute('data-faq-filter');
        filterByCategory(categoryId);

        // Scroll to the top of the FAQ items
        var faqItems = section.querySelector('.faq__items');
        if (faqItems) {
          var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
          var navHeight = 60;
          var targetPosition = faqItems.getBoundingClientRect().top + window.pageYOffset - headerHeight - navHeight;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });

    // Search input handler
    if (searchInput) {
      searchInput.addEventListener('input', debounce(function (e) {
        filterBySearch(e.target.value);
      }, 300));
    }

    // Initialize with all visible
    filterByCategory('all');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
